export default "__VITE_ASSET__D$LSltU1__"